import React from 'react';
import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useStyles } from '../styles';
import { TabIndex } from '../types';

interface EmptyStateProps {
  activeTab: number;
}

export const EmptyState: React.FC<EmptyStateProps> = ({ activeTab }) => {
  const classes = useStyles();
  const { t } = useTranslation();

  const getEmptyStateMessage = () => {
    switch (activeTab) {
      case TabIndex.PENDING:
        return {
          title: t('projectList.emptyState.pending.title'),
          subtitle: t('projectList.emptyState.pending.subtitle'),
        };
      case TabIndex.PAST:
        return {
          title: t('projectList.emptyState.past.title'),
          subtitle: t('projectList.emptyState.past.subtitle'),
        };
      case TabIndex.CURRENT:
        return {
          title: t('projectList.emptyState.current.title'),
          subtitle: t('projectList.emptyState.current.subtitle'),
        };
      case TabIndex.ALL:
        return {
          title: t('projectList.emptyState.all.title'),
          subtitle: t('projectList.emptyState.all.subtitle'),
        };
      default:
        return {
          title: t('projectList.emptyState.default.title'),
          subtitle: t('projectList.emptyState.default.subtitle'),
        };
    }
  };

  const { title, subtitle } = getEmptyStateMessage();

  return (
    <Box className={classes.emptyState} data-testid="project-list-empty-state">
      <div className={classes.emptyStateIcon}>📋</div>
      <Typography variant="h5" className={classes.emptyStateTitle} data-testid="project-list-empty-state-title">
        {title}
      </Typography>
      <Typography variant="body1" className={classes.emptyStateSubtitle}>
        {subtitle}
      </Typography>
    </Box>
  );
};
